<div class="modal-content mt-2" *ngIf="message">
    <!-- Header del Modal -->
    <div class="modal-header bg-gradient-primary text-white">
        <div class="d-flex align-items-center gap-3">
            <i class="fas fa-gift fa-2x"></i>
            <div>
                <h4 class="modal-title mb-0">{{ message!.titulo }}</h4>
                <small class="text-white-50">¡Oferta exclusiva para ti!</small>
            </div>
        </div>
        <button type="button" class="btn-close btn-close-white" (click)="activeModal.dismiss('Cross click')"
            aria-label="Close"></button>
    </div>

    <!-- Body del Modal -->
    <div class="modal-body p-0">
        <div *ngIf="message.fecha_expiracion" class="row g-0 p-1">
            <!-- Fechas de vigencia -->
            <div class="alert alert-info d-flex align-items-center mb-4" role="alert">
                <i class="fas fa-calendar-alt me-2"></i>
                <div class="small">
                    <strong>Promoción válida hasta {{ formatDate(message!.fecha_expiracion) }}.</strong>
                </div>
            </div>
        </div>


        <div class="row g-0">
            <!-- Columna de Imagen -->
            <div class="col-lg position-relative" *ngIf="message!.url_imagen">
                <div class="promo-image-container">
                    <img [src]="imageUrl" [alt]="message!.titulo" class="img-fluid w-100 h-100"
                        style="object-fit: contain; min-height: 400px;">
                    <div class="promo-badge">
                        <i class="fas fa-star"></i>
                        <span>PROMOCIÓN</span>
                    </div>
                </div>
            </div>

            <!-- Columna de Contenido -->
            <div class="col-lg">
                <div class="p-4">

                    <!-- Características destacadas -->
                    <div class="features-list mb-4">
                        <h5 class="text-primary mb-2">
                            <i class="fas fa-circle-info me-2"></i>Detalle de la promoción
                        </h5>
                        <!-- Contenido de la promoción -->
                        <div class="promo-content mb-4">
                            <div [innerHTML]="message!.contenido" class="formatted-content"
                                style="white-space: pre-line;"></div>
                        </div>
                    </div>


                    <!-- Información adicional -->
                    <!--div class="info-box p-3 bg-light rounded">
                        <div class="d-flex align-items-start gap-2">
                            <i class="fas fa-info-circle text-primary mt-1"></i>
                            <div class="small text-muted">
                                Esta es una oferta exclusiva para usuarios activos del sistema.
                                No pierdas esta oportunidad de mejorar tu experiencia.
                            </div>
                        </div>
                    </div-->                   
                </div>
            </div>
        </div>

        <div class="row g-0" *ngIf="message.fecha_expiracion">
            <!-- Contador de tiempo o mensaje de expiración -->
            <div class="countdown-timer mb-4 px-3">
                <!-- Oferta expirada -->
                <div *ngIf="isExpired()" class="text-center p-3 bg-danger text-white rounded">
                    <i class="fas fa-clock me-2"></i>
                    <strong>Esta oferta ha expirado</strong>
                </div>

                <!-- Contador activo -->
                <div *ngIf="!isExpired()" class="text-center p-3 bg-light rounded">
                    <div class="small text-muted mb-2">¡Oferta por tiempo limitado!</div>
                    <div class="d-flex justify-content-center align-items-center gap-2">
                        <div class="time-unit" *ngIf="getDaysRemaining() > 0">
                            <div class="time-value">{{ getDaysRemaining() }}</div>
                            <div class="time-label">días</div>
                        </div>
                        <div class="time-separator" *ngIf="getDaysRemaining() > 0">:</div>
                        <div class="time-unit">
                            <div class="time-value">{{ getHoursRemaining().toString().padStart(2, '0') }}</div>
                            <div class="time-label">horas</div>
                        </div>
                        <div class="time-separator">:</div>
                        <div class="time-unit">
                            <div class="time-value">{{ getMinutesRemaining().toString().padStart(2, '0') }}</div>
                            <div class="time-label">minutos</div>
                        </div>
                        <div class="time-separator">:</div>
                        <div class="time-unit">
                            <div class="time-value">{{ getSecondsRemaining().toString().padStart(2, '0') }}</div>
                            <div class="time-label">segundos</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer del Modal -->
    <div class="modal-footer bg-light">
        <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close()">
            <i class="fas fa-times me-2"></i>Cerrar
        </button>
        <button type="button" class="btn btn-primary" (click)="onSubmitAction()" *ngIf="!isExpired()">
            <i class="fas fa-check me-2"></i>¡Quiero esta oferta!
        </button>
        <!--button type="button" class="btn btn-info" (click)="onLearnMore()">
            <i class="fas fa-question-circle me-2"></i>Más información
        </button-->
    </div>
</div>